import React from 'react';
import { Col, Row, Button, Accordion, Card } from 'react-bootstrap'


export default function Gefaesgroesen(){
    
    return(
        <>
            <Col md={4}>
                <img className="img-fluid" src={require('../media/gefaese/gefaes_1.jpg')} />
                <table class="table table-sm">
                    <thead>
                        <tr>
                            <th scope="col">Länge (cm)</th>
                            <th scope="col">Breite (cm)</th>
                            <th scope="col">Höhe (cm)</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>200</td>
                            <td>200</td>
                            <td>80</td>
                        </tr>
                        <tr>
                            <td>200</td>
                            <td>200</td>
                            <td>60</td>
                        </tr>
                        <tr>
                            <td>200</td>
                            <td>200</td>
                            <td>40</td>
                        </tr>
                        <tr>
                            <td>140</td>
                            <td>140</td>
                            <td>80</td>
                        </tr>
                        <tr>
                            <td>140</td>
                            <td>140</td>
                            <td>60</td>
                        </tr>
                        <tr>
                            <td>140</td>
                            <td>140</td>
                            <td>40</td>
                        </tr>
                        <tr>
                            <td>120</td>
                            <td>120</td>
                            <td>80</td>
                        </tr>
                        <tr>
                            <td>120</td>
                            <td>120</td>
                            <td>60</td>
                        </tr>
                        <tr>
                            <td>120</td>
                            <td>120</td>
                            <td>40</td>
                        </tr>
                        <tr>
                            <td>100</td>
                            <td>100</td>
                            <td>100</td>
                        </tr>
                        <tr>
                            <td>100</td>
                            <td>100</td>
                            <td>80</td>
                        </tr>
                        <tr>
                            <td>100</td>
                            <td>100</td>
                            <td>60</td>
                        </tr>
                        <tr>
                            <td>100</td>
                            <td>100</td>
                            <td>40</td>
                        </tr>
                        <tr>
                            <td>80</td>
                            <td>80</td>
                            <td>80</td>
                        </tr>
                        <tr>
                            <td>80</td>
                            <td>80</td>
                            <td>60</td>
                        </tr>
                        <tr>
                            <td>80</td>
                            <td>80</td>
                            <td>40</td>
                        </tr>
                        <tr>
                            <td>70</td>
                            <td>70</td>
                            <td>70</td>
                        </tr>
                        <tr>
                            <td>60</td>
                            <td>60</td>
                            <td>60</td>
                        </tr>
                        <tr>
                            <td>50</td>
                            <td>50</td>
                            <td>50</td>
                        </tr>
                        <tr>
                            <td>40</td>
                            <td>40</td>
                            <td>40</td>
                        </tr>
                    </tbody>
                </table>
            </Col>
            
            <Col md={4}>
                <img className="img-fluid" src={require('../media/gefaese/gefaes_2.jpg')} />
                <table class="table table-sm">
                    <thead>
                        <tr>
                            <th scope="col">Länge (cm)</th>
                            <th scope="col">Breite (cm)</th>
                            <th scope="col">Höhe (cm)</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>200</td>
                            <td>100</td>
                            <td>60</td>
                        </tr>
                        <tr>
                            <td>200</td>
                            <td>100</td>
                            <td>40</td>
                        </tr>
                        <tr>
                            <td>200</td>
                            <td>50</td>
                            <td>60</td>
                        </tr>
                        <tr>
                            <td>150</td>
                            <td>50</td>
                            <td>60</td>
                        </tr>
                        <tr>
                            <td>120</td>
                            <td>50</td>
                            <td>60</td>
                        </tr>
                        <tr>
                            <td>90</td>
                            <td>50</td>
                            <td>60</td>
                        </tr>
                        <tr>
                            <td>200</td>
                            <td>50</td>
                            <td>50</td>
                        </tr>
                        <tr>
                            <td>150</td>
                            <td>50</td>
                            <td>50</td>
                        </tr>
                        <tr>
                            <td>120</td>
                            <td>50</td>
                            <td>50</td>
                        </tr>
                        <tr>
                            <td>100</td>
                            <td>50</td>
                            <td>50</td>
                        </tr>
                        <tr>
                            <td>200</td>
                            <td>40</td>
                            <td>80</td>
                        </tr>
                        <tr>
                            <td>150</td>
                            <td>40</td>
                            <td>80</td>
                        </tr>
                        <tr>
                            <td>120</td>
                            <td>40</td>
                            <td>80</td>
                        </tr>
                        <tr>
                            <td>100</td>
                            <td>40</td>
                            <td>80</td>
                        </tr>
                        <tr>
                            <td>80</td>
                            <td>40</td>
                            <td>80</td>
                        </tr>
                        <tr>
                            <td>200</td>
                            <td>40</td>
                            <td>40</td>
                        </tr>
                        <tr>
                            <td>150</td>
                            <td>40</td>
                            <td>40</td>
                        </tr>
                        <tr>
                            <td>120</td>
                            <td>40</td>
                            <td>40</td>
                        </tr>
                        <tr>
                            <td>100</td>
                            <td>40</td>
                            <td>40</td>
                        </tr>
                        <tr>
                            <td>80</td>
                            <td>40</td>
                            <td>40</td>
                        </tr>
                        <tr>
                            <td>90</td>
                            <td>30</td>
                            <td>80</td>
                        </tr>
                    </tbody>
                </table>
            </Col>

            <Col md={4}>
                <img className="img-fluid" src={require('../media/gefaese/gefaes_3.jpg')} />
                <table class="table table-sm">
                    <thead>
                        <tr>
                            <th scope="col">Länge (cm)</th>
                            <th scope="col">Breite (cm)</th>
                            <th scope="col">Höhe (cm)</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>50</td>
                            <td>50</td>
                            <td>80</td>
                        </tr>
                        <tr>
                            <td>50</td>
                            <td>50</td>
                            <td>100</td>
                        </tr>
                        <tr>
                            <td>40</td>
                            <td>40</td>
                            <td>60</td>
                        </tr>
                        <tr>
                            <td>40</td>
                            <td>40</td>
                            <td>80</td>
                        </tr>
                        <tr>
                            <td>40</td>
                            <td>40</td>
                            <td>100</td>
                        </tr>
                    </tbody>
                </table>
            </Col>  
        </>
    )
}